module.exports = __webpack_public_path__ + "img/secondimg.bc8f2e0f.svg";